module.exports = __webpack_public_path__ + "img/title-bg.f46fe3e9.png";